import { z } from 'zod';
import {
  emailSchema,
  phoneSchema,
  email,
  password,
} from '../sharedValidations';
import errors from '../errors';

export const loginSchema = (lang: 'en' | 'de') =>
  z.object({
    username: emailSchema,
    password: z.string().min(8, errors.password[lang]),
  });

export const customerLoginSchema = (lang: 'en' | 'de') =>
  z.object({
    username: email(lang),
    password: password(lang),
    device_token: z.string().optional().nullable(),
  });

export const resLoginSchema = (lang: 'en' | 'de') =>
  z.object({
    username: email(lang),
    password: password(lang),
    device_token: z.string().optional().nullable(),
  });

export const forgotPasswordSchema = z.object({
  email: emailSchema,
});

export const resetPasswordSchema = (lang: 'en' | 'de') =>
  z
    .object({
      password: z.string().min(8, errors.password[lang]),
      password_confirmation: z.string().min(8, errors.password_mismatch[lang]),
    })
    .refine((data) => data.password_confirmation === data.password, {
      message: errors.password_mismatch[lang],
      path: ['password_confirmation'],
    });

export const registerSchema = (lang: 'en' | 'de') =>
  z
    .object({
      firstName: z.string().min(2, { message: errors.first_name_min[lang] }),
      lastName: z.string().min(2, { message: errors.last_name_min[lang] }),
      device_token: z.string().optional().nullable(),
      email: emailSchema,
      otp: z.coerce.number().refine((value) => value >= 1000 && value <= 9999, {
        message: errors.otp[lang],
      }),
      phone: phoneSchema(lang, false),
      password: z.string().refine(
        (value) => {
          if (value.length < 8) {
            return false;
          } else {
            return true;
          }
        },
        {
          message: errors.password[lang],
        }
      ),
      confirm_password: z.string().refine(
        (value) => {
          if (value.length < 8) {
            return false;
          } else {
            return true;
          }
        },
        {
          message: errors.password[lang],
        }
      ),
    })
    .refine((data) => data.confirm_password === data.password, {
      message: errors.password_mismatch[lang],
      path: ['confirm_password'],
    });

export const registerOTPSchema = (lang: 'en' | 'de') =>
  z.object({
    email: z.string().email({ message: errors.email[lang] }),
    ['g-recaptcha-response']: z.string().optional(),
  });

// export const otpSchema = z.object({
//   otp: z.string().min(4, { message: 'OTP must be 4 digits' }),
// });
